// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card[data-v-d677be7c]{max-width:60%;min-width:10rem}.modal-card-body[data-v-d677be7c]{flex-direction:column;min-height:12rem}.input[data-v-d677be7c]{min-width:10rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
